export default __webpack_public_path__ + "static/media/vip-scanner-selected.704a755b.svg";